/* eslint-disable @typescript-eslint/no-explicit-any */
import Link, { LinkProps } from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { IconButton, Box, useTheme } from "@mui/material";
import { useBreadcrumbsContent } from "../../hooks/breadcrumbsContent";

const breadcrumbNameMap: { [key: string]: string } = {
  "/helpDesk": "Help Desk",
  "/helpDesk/tickets": "Tickets",
  "/helpDesk/tickets/new": "Novo",
  "/helpDesk/forms": "Formulários",
  "/helpDesk/forms/new": "Novo formulário",
  "/global": "Global",
  "/global/audits": "Auditoria",
  "/global/profiles": "Perfis de Permissões",
  "/global/profiles/new": "Novo",
  "/global/users": "Usuarios",
  "/global/users/new": "Novo",
  "/global/apikeys": "Chaves de API",
  "/global/apikeys/new": "Nova",
  "/global/field-catalog-permissions": "Permissões de Campos",
  "/global/aiPathologyAnalyses": "Análises de IA",
  "/global/aiPathologyAnalyses/new": "Nova",
  "/global/aiPathologySchedules": "Agendamentos de Analises de IA Patologias",
  "/global/aiPathologySchedules/new": "Novo",
  "/towermanagement/ehs": "Sistema EHS",
  "/towermanagement": "Gerenciamento de torres",
  "/towermanagement/customers": "Clientes",
  "/towermanagement/customers/new": "Novo",
  "/towermanagement/customer/requesters": "Solicitantes",
  "/towermanagement/customer/requesters/new": "Novo Solicitante",
  "/towermanagement/items": "Itens",
  "/towermanagement/items/new": "Novo",
  "/towermanagement/sites": "Sites",
  "/towermanagement/sites/new": "Novo",
  "/towermanagement/towers": "Torres",
  "/towermanagement/towers/new": "Novo",
  "/towermanagement/maintenances": "Manutenções",
  "/towermanagement/maintenances/new": "Novo",
  "/towermanagement/outsourcedes": "Terceirizadas",
  "/towermanagement/outsourcedes/new": "Novo",
  "/towermanagement/outsourcedes/*/teams": "Equipes",
  "/towermanagement/routings": "Roteirização",
  "/towermanagement/routings/new": "Novo",
  "/towermanagement/plannings_maintenances": "Planejamentos",
  "/towermanagement/plannings_maintenances/new": "Novo",
  "/towermanagement/services": "Serviços",
  "/towermanagement/services/new": "Novo",
  "/towermanagement/services/scope": "Escopos",
  "/towermanagement/services/scope/new": "Escopos",
  "/towermanagement/statuses": "Status",
  "/towermanagement/statuses/new": "Novo",
  "/towermanagement/stages": "Etapas",
  "/towermanagement/stages/new": "Novo",
  "/towermanagement/stages/:idStage": "Etapa",
  "/towermanagement/measurements": "Medições",
  "/towermanagement/measurements/new": "Novo",
  "/towermanagement/activities": "Atividades",
  "/towermanagement/activities/new": "Novo",
  "/towermanagement/forms": "Formulários",
  "/towermanagement/formResponses": "Formulários Respondidos",
  "/towermanagement/forms/new/fields": "Aba Campos",
  "/towermanagement/forms/new/categories": "Aba Categorias",
  "/towermanagement/contracts": "Contratos",
  "/towermanagement/contracts/new": "Novos",
  "/towermanagement/pricing_plans": "Planos de precificação",
  "/towermanagement/pricing_plans/new": "Novo",
  "/towermanagement/pricing_values": "Valores",
  "/towermanagement/attributions": "Atribuições",
  "/towermanagement/access-requests": "Controle de Acesso",
  "/towermanagement/access-requests/requests": "Solicitação",
  "/towermanagement/access-requests/pending": "Pendente Acesso",
  "/towermanagement/access-requests/assignments": "Cadastro de Acesso",
  "/towermanagement/timeline": "Linha do tempo",
  "/towermanagement/unitOfMeasures": "Unidade de Medida",
  "/towermanagement/pathologies": "Patologias",
  "/towermanagement/occurrenceTypes": "Tipos de Ocorrência",
  "/towermanagement/slas": "SLAs",
  "/towermanagement/slas/new": "Novo",
  "/towermanagement/slas/*/teams": "Equipes",
  "/towermanagement/dashboards/3": "Operação",
  "/towermanagement/dashboards/4": "Qualidade",
  "/towermanagement/dashboards/7": "Auditoria",
  "/towermanagement/dashboards/11": "Controle de Produção - Corretiva",
  "/towermanagement/dashboards/16": "Índice de Conformidade",
  "/towermanagement/dashboards/18": "Controle de Pendências",
  "/towermanagement/dashboards/21": "Controle de Produção - Preventiva",
  "/towermanagement/app-tutorial": "Tutorial do App",
  "/towermanagement/equipments": "Equipamentos",
  "/towermanagement/equipments/new": "Novo",
  "/towermanagement/equipments/categoryEquipment": "Categorias",
  "/towermanagement/equipments/categoryEquipment/new": "Nova",
  "/financial": "Financeiro",
  "/financial/customers_suppliers": "Clientes/Fornecedores",
  "/financial/entries": "Lançamentos",
  "/financial/entries/receivable": "A Receber",
  "/financial/entries/payable": "A Pagar",
  "/financial/entries/all": "Todos",
  "/financial/entries/new": "Nova",
  "/financial/entry-payment-terms": "Parcelamentos",
  "/financial/invoices": "Faturas",
  "/financial/invoices/new": "Nova",
  "/financial/release-reconciliation": "Conciliação de Liberação",
  "/financial/cash_accounts": "Contas caixa",
  "/financial/cash_accounts/new": "Nova",
  "/financial/payment-terms": "Condições de Pagamento",
  "/financial/payment-terms/new": "Nova",
  "/financial/managerialCategory": "Categorias Gerenciais",
  "/financial/cost-centers": "Centros de Custo",
  "/financial/dashboards": "Dashboards",
  "/financial/dashboards/new": "Novo",
  "/projectManagement": "Gerenciamento de Obras",
  "/projectManagement/gantt": "Cronograma",
  "/projectManagement/projects": "Obras",
  "/projectManagement/project-types": "Tipos de Obra",
  "/projectManagement/stage-types": "Tipos de Etapa",
  "/projectManagement/cost-categories": "Categorias de Custo",
  "/projectManagement/demand-origins": "Origens de Demanda",
  "/projectManagement/cadastros": "Cadastros",
  "/projectManagement/projects/costs": "Custos",
  "/projectManagement/projects/receivablePlans": "Recebimentos",
  "/projectManagement/projects/files": "Arquivos",
  "/projectManagement/projects/occurrences": "Ocorrências",
  "/home": "Início",
  "/dashboard": "Dashboard",
  "/towermanagement/approval_flow_execution_steps": "Etapas de Aprovação",
  "/towermanagement/approval-flows": "Fluxos de Aprovação",
  "/towermanagement/approval-flows/builder": "Construtor",
  "/global/team_users": "Usuário de Equipes",
  "/": "Início",
  "/spam": "Spam",
  "/drafts": "Drafts",
};

interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
}

function LinkRouter(props: LinkRouterProps) {
  return <Link {...props} component={RouterLink as any} />;
}

export function BreadcrumbsCustom({
  hideInLayout = false,
  children,
}: {
  hideInLayout?: boolean;
  children?: React.ReactNode;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const { content } = useBreadcrumbsContent();
  const pathnames = location.pathname.split("/").filter(Boolean);

  if (hideInLayout) {
    return null;
  }

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <IconButton
        onClick={handleGoBack}
        sx={{
          color: theme.palette.text.primary,
          backgroundColor: "transparent",
          borderRadius: "8px",
          width: "20px",
          height: "20px",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            color: "white",
            transform: "translateX(-2px)",
          },
        }}
        title="Voltar"
      >
        <ArrowBackIcon fontSize="small" />
      </IconButton>

      <Breadcrumbs
        aria-label="breadcrumb"
        separator={
          <NavigateNextIcon
            fontSize="small"
            sx={{ color: theme.palette.grey[500] }}
          />
        }
        sx={{
          marginLeft: "0px",
          color: theme.palette.text.secondary,
          "& .MuiBreadcrumbs-separator": {
            margin: "0 4px",
          },
        }}
      >
        {pathnames.length === 0 ? (
          <Typography
            sx={{
              color: theme.palette.text.secondary,
              fontSize: "0.80rem",
              fontWeight: 600,
              textTransform: "capitalize",
              letterSpacing: "0.02em",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          ></Typography>
        ) : (
          pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;
            const lastName = to.split("/").pop();
            const isDynamic = !breadcrumbNameMap[to] && !isNaN(Number(value));
            let bread = breadcrumbNameMap[to];
            // id na URL não herda o nome de outra tela com o mesmo número (ex.: fluxo 4 virava "Qualidade")
            if (!bread && !isDynamic) {
              const keys = Object.keys(breadcrumbNameMap);
              const route = keys.find((key) => {
                const lastPartRoute = key.split("/").pop();
                return lastPartRoute === lastName;
              });
              bread = breadcrumbNameMap[route];
            }
            const label =
              bread ||
              (isDynamic
                ? `${value}`
                : value.charAt(0)?.toUpperCase() + value.slice(1));

            return isLast ? (
              <Typography
                color="text.primary"
                sx={{
                  color: theme.palette.accentText,
                  fontSize: "0.80rem",
                  fontWeight: 600,
                  textTransform: "capitalize",
                  letterSpacing: "0.02em",
                }}
                key={to}
              >
                {label}
              </Typography>
            ) : (
              <LinkRouter
                underline="hover"
                color="inherit"
                to={to}
                key={to}
                sx={{
                  color: theme.palette.text.secondary,
                  fontSize: "0.80rem",
                  fontWeight: 500,
                  textDecoration: "none",
                  textTransform: "capitalize",
                  transition: "color 0.2s ease-in-out",
                  "&:hover": {
                    color: theme.palette.text.secondary,
                  },
                }}
              >
                {label}
              </LinkRouter>
            );
          })
        )}
      </Breadcrumbs>
      {content || children}
    </Box>
  );
}
